import {
  collection,
  getDoc,
  doc,
  query,
  getDocs,
  where,
} from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

async function getDeviceTokensFromFirestore(userId) {
  try {
    const DeviceTokensRef = query(
      collection(db, "users", userId, "device_ids")
    );
    const DeviceTokensRefSnapshot = await getDocs(DeviceTokensRef);
    let data = [];
    data = DeviceTokensRefSnapshot.docs.map((d) => d.id);

    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function getEmailFromFirestore(userId) {
  try {
    const userRef = query(doc(db, "users", userId));
    const userSnapshot = await getDoc(userRef);
    let data = userSnapshot.data();

    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function getUidFromFirestore(bid) {
  try {
    const userRef = query(doc(db, "clients", bid));
    const userSnapshot = await getDoc(userRef);
    let data = userSnapshot.data().uid;

    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function getUidFromFirestoreAgents(bid) {
  try {
    const UsersCollection = await collection(db, "users");

    let q = query(UsersCollection, where("bid", "==", bid));

    const UsersSnapshot = await getDocs(q);

    let Users = [];
    UsersSnapshot.docs.forEach((doc) => {
      Users.push(doc.data().createdBy);
    });

    const usersRefineArray = Users.filter(function (elem, pos) {
      return Users.indexOf(elem) == pos;
    });
    return usersRefineArray;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function getUidFromFirestoreDeals(pid) {
  try {
    const DealsCollection = await collection(db, "deals");

    let q = query(DealsCollection, where("property", "==", pid));

    const DealsSnapshot = await getDocs(q);

    let Deals = [];
    // DealsSnapshot.forEach((e) => Deals.push(e.createdBy));
    DealsSnapshot.docs.forEach((doc) => {
      Deals.push(doc.data().createdBy);
    });

    const dealsRefineArray = Deals.filter(function (elem, pos) {
      return Deals.indexOf(elem) == pos;
    });
    return dealsRefineArray;
  } catch (error) {
    console.log(error);
    return [];
  }
}
export async function getUidFromProperty(pid) {
  try {
    const userRef = query(doc(db, "properties", pid));
    const userSnapshot = await getDoc(userRef);
    if (userSnapshot.data().bid === getLocalStorageItem("bid")) {
      return "NO";
    }

    let data = userSnapshot.data().createdBy;

    return data;
  } catch (error) {
    console.log(error);
  }
}

export default getDeviceTokensFromFirestore;
